import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    business: null,
    customers: [],
    summary: {
      totalAmount: 0,
      pendingAmount: 0,
      count: 0
    },
    filters: {
      timeRange: "Total Data",
      customFromDate: "",
      customToDate: "",
      minAmount: 0,
      maxAmount: Infinity,
      visitCount: 0,
      searchMobile: ""
    }
  },
  loading: false,
  error: null,
};

const customerReportSlice = createSlice({
  name: "customerReport",
  initialState,
  reducers: {
    customerReportRequest(state) {
      state.loading = true;
      state.error = null;
    },
    customerReportSuccess(state, action) {
      state.loading = false;
      state.data = {
        ...action.payload.data,
        filters: {
          ...state.data.filters,
          ...action.payload.data.filters
        }
      };
    },
    customerReportFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetCustomerReport(state) {
      state.loading = false;
      state.error = null;
      state.data = initialState.data;
    },
    updateCustomerReportFilters(state, action) {
      state.data.filters = {
        ...state.data.filters,
        ...action.payload
      };
    }
  },
});

export const {
  customerReportRequest,
  customerReportSuccess,
  customerReportFailure,
  resetCustomerReport,
  updateCustomerReportFilters
} = customerReportSlice.actions;

export default customerReportSlice.reducer;